import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SingleResponseModel } from '../../../../common/models/single-response.model';



import { CreditActionTypes , CreditActions, LoadCreditsSuccess} from '../actions/credit.actions';
import { SummaryCreditModel } from '../../models/summary-credit.model';


export interface CreditState {
  items: SummaryCreditModel[];
  total: number;
  res: PaginableResponseModel<SummaryCreditModel>;
  selected: SingleResponseModel<SummaryCreditModel> | null;
  loading: boolean;
  error: any
}


export const initalState: CreditState = {
  items: [],
  total: 0,
  res: null,
  selected: null,
  loading: false,
  error: null
};

export function CreditReducer(
  state = initalState,
  action: CreditActions
): CreditState {
  switch (action.type) {
    case CreditActionTypes.LoadCredits:
      return { ...state, loading: true, error: null };

    case CreditActionTypes.LoadCreditsSuccess:
      const { items, total } = (action as LoadCreditsSuccess).payload;

      return {
        ...state,
        loading: false,
        error: null,
        items: items,
        total: total,
      };

    case CreditActionTypes.LoadCreditsFailure:
       return { ...state, loading: false, error: action.payload.error };

    case CreditActionTypes.LoadCreditSuccess:
      return {
        ...state,
        selected: action.payload
      };

    default:
      return state;
  }
}
